export const environment = {
  production: true,
  apiUrl: 'https://api.live.bomoart.com/api/v1',
  mapsAPIKey: 'AIzaSyDhLOEz8kO5p_Md46_62-8tGAGvj8KdRI4',
};
